// @material-ui/core
import { Fade, Snackbar, Typography } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const styles = theme => ({
  root: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "none"
  }
});

class Notification extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(["info", "success", "warning", "error"]),
    title: PropTypes.node,
    message: PropTypes.node.isRequired,
    timeOut: PropTypes.number,
    onClick: PropTypes.func,
    onRequestHide: PropTypes.func,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      type: "info",
      title: null,
      message: null,
      timeOut: 5000,
      onClick: () => {},
      onRequestHide: () => {},
      open: true
    };
  }

  componentDidMount = () => {
    const { timeOut } = this.props;
    if (timeOut !== 0) {
      this.timer = setTimeout(this.requestHide, timeOut);
    }
  };

  componentWillUnmount = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    this.requestHide();
  };

  requestHide = () => {
    const { onRequestHide } = this.props;
    if (onRequestHide) {
      onRequestHide();
    }
  };

  render() {
    const { type, title, message, status, classes, index } = this.props;
    return (
      <Snackbar
        onClick={this.handleClick}
        className={classnames([
          "notification",
          `notification-${type}`,
          `notification-${index}`
        ])}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={this.state.open}
        transition={Fade}
        SnackbarContentProps={{
          "aria-describedby": "message-id",
          classes: {
            root: classes.root
          }
        }}
        message={
          <Typography
            variant="subheading"
            color="inherit"
            className={this.props.className}>
            {status && <b>#{status}</b>}
            <small>{title}</small>
            <br />
            {message}
          </Typography>
        }
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(Notification);



// WEBPACK FOOTER //
// ./src/library/notifications/Notification.js